import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFridge: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="fridge"><path d="M4.75 2.75H19.25V21.5H4.75V2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.25 6.75V7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.25 14.25V15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19 11H5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFridge;
